/**
 * Arquivo: src/pages/Login.tsx
 * Versão: 6.0.0
 * Data: 08/10/2026
 */
import { FormEvent, useState } from 'react'
import { Eye, EyeOff } from 'lucide-react'
import { neonAuth, neonAuthConfigured } from '../services/neonAuth'

export default function Login() {
  const [email, setEmail] = useState('')
  const [senha, setSenha] = useState('')
  const [erro, setErro] = useState('')
  const [loading, setLoading] = useState(false)
  const [mostrarSenha, setMostrarSenha] = useState(false)
  const [resetLoading, setResetLoading] = useState(false)
  const [aviso, setAviso] = useState('')

  async function entrar(event: FormEvent) {
    event.preventDefault()
    setErro('')

    if (!neonAuthConfigured) {
      setErro('Configure o arquivo .env antes de entrar.')
      return
    }

    const emailNormalizado = email.trim().toLowerCase()

    setLoading(true)
    try { await neonAuth.signIn(emailNormalizado, senha) }
    catch (error) { setErro(error instanceof Error ? error.message : 'Não foi possível entrar.') }
    finally { setLoading(false) }
  }

  async function recuperarSenha() {
    setErro('')
    setAviso('')
    const emailNormalizado = email.trim().toLowerCase()
    if (!emailNormalizado) {
      setErro('Informe seu e-mail para receber o link de redefinição.')
      return
    }
    setResetLoading(true)
    try {
      await neonAuth.requestPasswordReset(emailNormalizado)
      setAviso('Enviamos um link seguro para redefinir sua senha. Verifique seu e-mail.')
    } catch (error) {
      setErro(error instanceof Error ? error.message : 'Não foi possível enviar o link de redefinição.')
    } finally {
      setResetLoading(false)
    }
  }

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={entrar}>
        <div className="login-brand ff-login-brand">
          <img className="ff-login-logo" src="/ff-logo.png" alt="Controle Financeiro" />
        </div>

        <label>E-mail</label>
        <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" autoComplete="username" required />

        <label>Senha</label>
        <div className="password-field">
          <input value={senha} onChange={(e) => setSenha(e.target.value)} type={mostrarSenha ? 'text' : 'password'} autoComplete="current-password" required />
          <button type="button" className="password-toggle" onClick={() => setMostrarSenha(v => !v)} title={mostrarSenha ? 'Ocultar senha' : 'Mostrar senha'} aria-label={mostrarSenha ? 'Ocultar senha' : 'Mostrar senha'}>
            {mostrarSenha ? <EyeOff size={20}/> : <Eye size={20}/>}
          </button>
        </div>

        {erro && <div className="error-box">{erro}</div>}
        {aviso && <div className="success-box">{aviso}</div>}
        <button className="primary-button" disabled={loading || resetLoading}>{loading ? 'Entrando...' : 'Entrar'}</button>
        <button type="button" className="login-reset-link" disabled={loading || resetLoading} onClick={() => void recuperarSenha()}>
          {resetLoading ? 'Enviando link...' : 'Esqueci minha senha'}
        </button>
      </form>
    </div>
  )
}
